import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'my-nav',
  styles: [
    `
    .pane{
      padding: 1em;
    }
  `
  ],
  template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
      <ng-container *ngIf="template"
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ navs: dataContext }"
      >
          <app-simple-ms
            [WsData] = this.dataContext
            (AbrirNuevoNav)="AbrirNuevoNavDetalle($event)"
          ></app-simple-ms>
      </ng-container>
    </div>
  `
})
export class NavComponent implements OnInit {
  
  @Input('navTitle') title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() dataContext;

  @Output() AbrirNuevoNav = new EventEmitter<string>(); 


  ngOnInit(): void {
  }

  AbrirNuevoNavDetalle(Data){
    this.AbrirNuevoNav.emit(Data);
  }

}

